import React, { useRef } from "react";
import { format } from "date-fns";
import { useInView } from "framer-motion";

export default function BlogPostCard({ data }) {
   const firstParagraph = data?.content?.blocks?.find((block) => block?.type === "Paragraph");
   var paragraphText = "";
   if (firstParagraph) {
      // Extract the HTML content of the first paragraph
      const paragraphHTML = firstParagraph.data.text;

      // Use a regular expression to remove HTML tags and then get the first 150 characters
      paragraphText = paragraphHTML.replace(/<[^>]*>/g, "").substring(0, 105);
   }
   const ref = useRef(null);
   const isInView = useInView(ref, { once: false });

   return (
      <div ref={ref} className="blogPost__Card__SliderWrapper py-2">
         <a href={`/company/blogs/${data?._id}`}>
            <div
               className="blogPost__Card"
               style={{
                  transform: isInView ? "none" : "translateX(-100vw)",
                  opacity: isInView ? 1 : 0,
                  transition: "all 0.8s ",
               }}
            >
               <img
                  src={`${process.env.REACT_APP_FILE_URL}/${data?.featured_image}`}
                  alt=""
                  className="blogPost__Card__image"
               />
               <div className="blogPost__Card__details">
                  <div className="blogPost__Card__details__date">
                     <p className="bigDate">{format(new Date(data?.created_at), "dd")}</p>
                     <p className="indv_date">
                        <span>{format(new Date(data?.created_at), "yyyy")}</span>
                        <span>{format(new Date(data?.created_at), "MMMM")}</span>
                     </p>
                  </div>
                  <h4 className="blogPost__Card__details__title">{data?.title}</h4>
                  <h4 className="blogPost__Card__details__description">{paragraphText}...</h4>
               </div>
            </div>
         </a>
      </div>
   );
}
